export enum DeductionFrequency {
	AllPays = 1,
	OnceAMonth = 2,
	TwiceAMonth = 3,
}
